import gql from 'graphql-tag';

import { EVENT_INFO } from './event.info';
// import { QUESTIONS, QUESTIONS_WITH_ANSWERS } from './question';
// import { COLLECTION_FRAGMENT } from './collections';
import { PHOTO_FRAGMENT } from './photo';

export const SCHEDULE_FRAGMENT = gql`
  fragment ScheduleFragment on EventInfo {
    schedule {
      id
      name
      description
      dressCode
      startTime
      endTime
      timezone
      location
      showMap
      unplugged
    }
  }
`;

export const GUEST_SITE_PAGE_FRAGMENT = gql`
  ${PHOTO_FRAGMENT}
  fragment GuestSitePagesFragment on Event {
    pages {
      id
      type
      photo {
        ...PhotoFragment
      }
      mobilePhoto {
        ...PhotoFragment
      }
      private
      disabled
      pageSlug
      pageTitle
      pageSubTitle
    }
  }
`;

export const STYLE_FRAGMENT = gql`
  fragment StyleFragment on Event {
    style {
      id
      layout
      accent
      primaryColor
      secondaryColor
      primaryTextColor {
        hex
      }
      translucent
      light
      suggestedColor
      backgroundType
      theme
      border
      font
    }
  }
`;

export const VIP_FRAGMENT = gql`
  fragment VipFragment on Vip {
    id
    title
    alias
    description
    photo {
      id
      url
      width
      height
    }
  }
`;

// export const EVENT_COLLECTIONS = gql`
//   ${COLLECTION_FRAGMENT}
//   query eventCollections($id: ID!) {
//     event(id: $id) {
//       id
//       collections {
//         ...CollectionFragment
//       }
//     }
//   }
// `;

export const EVENT_FRAGMENT = gql`
  ${EVENT_INFO}
  ${GUEST_SITE_PAGE_FRAGMENT}
  ${SCHEDULE_FRAGMENT}
  ${STYLE_FRAGMENT}
  ${VIP_FRAGMENT}
  fragment EventFragment on Event {
    id
    eventId
    website
    # vendorTestStatus
    settings {
      hideEventCountdown
    }
    info {
      ...EventInfoFragment
      ...ScheduleFragment
    }
    ...GuestSitePagesFragment
    ...StyleFragment
    vips {
      ...VipFragment
    }
  }
`;

// export const SET_VENDOR_TEST_STATUS = gql`
//   mutation SetVendorTestStatus($eventId: String!, $status: String!) {
//     setVendorTestStatus(eventId: $eventId, status: $status)
//   }
// `;

// export const SEND_VENDOR_TEST_NOTE = gql`
//   mutation SendVendorTestNote($eventId: String!, $note: String!) {
//     sendVendorTestNote(eventId: $eventId, note: $note)
//   }
// `;

// export const GUEST_LIST = gql`
//   query GuestList($eventId: ID!) {
//     guestList(eventId: $eventId) {
//       columns {
//         key
//         title
//       }
//       rows {
//         cells {
//           key
//           answer {
//             id
//             value
//           }
//         }
//       }
//     }
//   }
// `;
